import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "label"]
  static values = { threshold: { type: Number, default: 100 } }

  connect() {
    this.ticking = false
    this.visible = false
    this.navbar = document.querySelector(".app-navbar")
    this.scrollHandler = this.onScroll.bind(this)
    window.addEventListener("scroll", this.scrollHandler, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler)
    if (this.navbar) {
      this.navbar.style.transform = ""
      this.navbar.style.opacity = ""
    }
  }

  onScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.update()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  update() {
    if (!this.hasBarTarget) return

    if (window.scrollY > this.thresholdValue) {
      if (!this.visible) {
        this.barTarget.style.transform = "translateY(0)"
        this.barTarget.style.opacity = "1"
        if (this.navbar) {
          this.navbar.style.transform = "translateY(-100%)"
          this.navbar.style.opacity = "0"
        }
        this.visible = true
      }
    } else {
      if (this.visible) {
        this.barTarget.style.transform = "translateY(-100%)"
        this.barTarget.style.opacity = "0"
        if (this.navbar) {
          this.navbar.style.transform = "translateY(0)"
          this.navbar.style.opacity = "1"
        }
        this.visible = false
      }
    }
  }

  switchTab(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    const label = event.currentTarget.querySelector("span:not(.sticky-category-count)").textContent
    
    // Update the label
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = label
    }
    
    // Find and click the corresponding tab button on the page
    const tabButton = document.querySelector(`[data-action="click->tabs#switch"][data-tab="${tab}"]`)
    if (tabButton) {
      tabButton.click()
      // Scroll to top of content
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    
    // Update active state in dropdown
    this.element.querySelectorAll('.sticky-category-item').forEach(item => {
      item.classList.remove('active')
    })
    event.currentTarget.classList.add('active')
    
    // Close dropdown
    const dropdownMenu = this.element.querySelector('.sticky-category-menu')
    if (dropdownMenu) {
      dropdownMenu.classList.add('hidden')
    }
  }
}
